export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      className="relative w-full min-h-[720px] md:min-h-[820px] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://static.readdy.ai/image/f943031b43fc8da94030f1522c0523e1/3c9fe98d3445147a9e01a53a2f4179c2.png')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 border border-primary-500/40 bg-background-50/20 backdrop-blur px-4 py-1.5 rounded-full mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
            <span className="text-xs md:text-sm text-primary-500 tracking-widest font-medium">
              INVESTMENT ADVISORY · SINCE 2025
            </span>
          </div>

          <h1 className="font-heading font-black text-4xl md:text-6xl lg:text-7xl leading-tight text-foreground-50 tracking-tight">
            시장을 읽는 힘,
            <br />
            <span className="text-gold-gradient">투자의 기준</span>을
            <br />
            제시합니다.
          </h1>

          <div className="gold-divider w-24 my-8"></div>

          <p className="text-base md:text-lg text-foreground-200 leading-relaxed max-w-2xl">
            프라임파트너스는 시장 분석을 기반으로
            <br className="hidden md:block" />
            회원 맞춤형 투자 정보를 제공하는
            <br className="hidden md:block" />
            유사투자자문 전문기업입니다.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo("#contact")}
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-4 rounded-md text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2"
            >
              무료 상담 신청
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollTo("#services")}
              className="border border-foreground-200/40 hover:border-primary-500 hover:text-primary-500 text-foreground-100 px-8 py-4 rounded-md text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2"
            >
              서비스 안내
            </button>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-4 md:gap-8 max-w-2xl">
            <div>
              <div className="font-heading font-black text-2xl md:text-4xl text-primary-500">
                17<span className="text-foreground-300 text-lg md:text-2xl">년</span>
              </div>
              <div className="text-xs md:text-sm text-foreground-300 mt-1">투자 자문 경력</div>
            </div>
            <div>
              <div className="font-heading font-black text-2xl md:text-4xl text-primary-500">
                98.6<span className="text-foreground-300 text-lg md:text-2xl">%</span>
              </div>
              <div className="text-xs md:text-sm text-foreground-300 mt-1">회원 만족도</div>
            </div>
            <div>
              <div className="font-heading font-black text-2xl md:text-4xl text-primary-500">
                1,280<span className="text-foreground-300 text-lg md:text-2xl">명</span>
              </div>
              <div className="text-xs md:text-sm text-foreground-300 mt-1">활성 회원</div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollTo("#about")}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-foreground-200 hover:text-primary-500 text-xs tracking-widest flex flex-col items-center gap-1 cursor-pointer"
      >
        <span>SCROLL</span>
        <i className="ri-arrow-down-line text-lg"></i>
      </button>
    </section>
  );
}
